import axios from 'axios';
export const baseURL = 'https://api.froz.dzyris.in'
  
const api = axios.create({
  baseURL
});

export default api;